//JS LIBRARIES
global.Collapse = require('bootstrap/js/dist/collapse');
global.Offcanvas = require('bootstrap/js/dist/offcanvas');
global.Modal = require('bootstrap/js/dist/modal');
require('../../scripts-optimized/polyfills');
require('../../scripts-optimized/core-web-vitals');
require('../../scripts/analytics-events');

//JS
require('../../scripts-optimized/Promotions/main');
require('../../scripts-optimized/Whatsapp/main');
require('../../scripts-optimized/HelpWidget/main');
require('../../scripts-optimized/MessageSOS/main');
require('../../scripts-optimized/Cookies/main');
require('../../scripts-optimized/Newsletter/main');
require('../../scripts-optimized/Country/Popup/main');
require('../../scripts-optimized/PopupSmarterClick/main');
require('../../scripts-optimized/Header/Messages/main');
require('../../scripts-optimized/Header/SearcherV2/main');
require ('../../scripts/User/access');
require('../../scripts-optimized/Header/LeftMenu/main');
require('../../scripts-optimized/Header/Login/main');
require('../../scripts-optimized/Header/Cart/main');
require('../../scripts-optimized/Header/OuterMenu/main');
require('../../scripts-optimized/Header/Breadcrumb/main');
require('../../scripts-optimized/LeftMenu/main');
require('../../scripts-optimized/Product/Size/main');
require('../../scripts-optimized/Product/Color/main');
require('../../scripts-optimized/Product/Pack/main');
require('../../scripts-optimized/Product/CustomText/main');
require('../../scripts-optimized/Product/CustomImage/main');
require('../../scripts-optimized/Product/GlassReversed/main');
require('../../scripts-optimized/Product/Tissue/main');
require('../../scripts-optimized/Product/TissueDrop/main');
require('../../scripts-optimized/Product/ChainPosition/main');
require('../../scripts-optimized/Product/SupportColor/main');
require('../../scripts-optimized/Product/ModelGender/main');
require('../../scripts-optimized/Product/Model/main');
require('../../scripts-optimized/Product/ModelSize/main');
require('../../scripts-optimized/Product/MaterialColor/main');
require('../../scripts-optimized/Product/Complement/main');
require('../../scripts-optimized/Tools/Textarea/main');
require('../../scripts-optimized/Tools/ScrollTopButton/main');
require('../../scripts-optimized/Tools/PopupImageZoom/main');
require('../../scripts-optimized/Wishlist/main');
require('../../scripts-optimized/Tools/PopupReviewImageZoom/main');

require('../../scripts-optimized/ProductPage/General/main');
require('../../scripts-optimized/ProductPage/PopupPersonalizedText/main');
require('../../scripts-optimized/ProductPage/ImageZoom/main');
require('../../scripts-optimized/ProductPage/ReviewImages/main');

require('../../scripts-optimized/Footer/Contact/main');
require('../../scripts-optimized/Footer/Newsletter/main');
require('../../scripts-optimized/Footer/Social/main');


//CSS
require('tom-select/dist/css/tom-select.css');
require('@splidejs/splide/dist/css/splide.min.css');
require('../../../../sass/website/Optimized/General/main.scss');
require('../../../../sass/website/Optimized/Newsletter/Popup/main.scss');
require('../../../../sass/website/Optimized/Cookies/Popup/main.scss');
require('../../../../sass/website/Optimized/Country/Popup/main.scss');
require('../../../../sass/website/Optimized/SmarterClick/Popup/main.scss');
require('../../../../sass/website/Optimized/Header/General/main.scss');
require('../../../../sass/website/Optimized/ProductPage/General/main.scss');
require('../../../../sass/website/Optimized/ProductPage/Options/Sizes/Wallpaper/main.scss');
require('../../../../sass/website/Optimized/ProductPage/Options/Customizer/Selectable/main.scss');
require('../../../../sass/website/Optimized/ProductPage/UpSellingPersonalizedText/main.scss');
require('../../../../sass/website/Optimized/Footer/General/main.scss');
require('../../../../sass/website/Optimized/ProductPage/Reviews/ReviewImages/main.scss');